import React from "react";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";

import "./assets/scss/index.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";

import App from "./App/App";
import store from "./system/store";
import { sentryInit } from "./system";
import reportWebVitals from "./reportWebVitals";
import ScrollToTop from "./shared/components/scroll-to-top/ScrollToTop";
import ErrorBoundary from "./shared/components/error-boundary/ErrorBoundary";

sentryInit();
const root = createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ErrorBoundary>
      <Router>
        {/* Scroll to top on route change */}
        <ScrollToTop />
        <App />
      </Router>
    </ErrorBoundary>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
